module.exports = __webpack_public_path__ + "img/iconRed.be5acb64.png";